export const AppRoutes = {
  Main: '',
  Gallery: 'gallery',
  Project: 'about',
  Join: 'join',
}
